var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsDateString, IsInt, IsOptional, IsString, IsUrl, MaxLength } from 'class-validator';
import { IsAfterDateOrEqual } from '../../utils/validators/is-after';
import { IsBeforeOrToday } from '../../utils/validators/is-before-now';
/**
 * Affected endpoints
 * POST /manfredite/work-experiences/<id>
 * PUT /manfredite/work-experiences/<id>
 */
export class WorkExperienceUpdateRequest {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], WorkExperienceUpdateRequest.prototype, "jobRole", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], WorkExperienceUpdateRequest.prototype, "description", void 0);
__decorate([
    IsDateString(),
    IsBeforeOrToday(),
    __metadata("design:type", Date)
], WorkExperienceUpdateRequest.prototype, "dateFrom", void 0);
__decorate([
    IsOptional(),
    IsDateString(),
    IsBeforeOrToday(),
    IsAfterDateOrEqual('dateFrom'),
    __metadata("design:type", Date)
], WorkExperienceUpdateRequest.prototype, "dateTo", void 0);
__decorate([
    IsInt({ each: true }),
    __metadata("design:type", Array)
], WorkExperienceUpdateRequest.prototype, "technologies", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    __metadata("design:type", String)
], WorkExperienceUpdateRequest.prototype, "organization", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    __metadata("design:type", Number)
], WorkExperienceUpdateRequest.prototype, "logoId", void 0);
__decorate([
    Expose(),
    IsUrl({ require_protocol: true }),
    MaxLength(255),
    IsOptional(),
    __metadata("design:type", String)
], WorkExperienceUpdateRequest.prototype, "url", void 0);
//# sourceMappingURL=work-experience-update.request.js.map